import { render, staticRenderFns } from "./PushNotifDropdown.vue?vue&type=template&id=0613f5ac&"
import script from "./PushNotifDropdown.vue?vue&type=script&lang=ts&"
export * from "./PushNotifDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports